import { render, staticRenderFns } from "./BaseVirtualScrollViewportItem.vue?vue&type=template&id=c9425ade"
import script from "./BaseVirtualScrollViewportItem.vue?vue&type=script&lang=ts"
export * from "./BaseVirtualScrollViewportItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_css-loader@7.1.2_webpack@5.99.8__ejs@3.1.10_handl_3jut7ceevhzic45wtfkktzvvoq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports